import { createStore } from 'vuex'

export default createStore({
  state: {
    phoneClass:true
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
